import { useMutation, useQueryClient } from 'react-query'

import { IUpdateQuantityTypeCategroyDto } from 'src/types'

import { QUERY_KEYS } from 'src/constants'
import { quantityTypeCategoryService } from 'src/services/quantity-type-category.service'

export const useUpdateQuantityTypeCategory = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (item: IUpdateQuantityTypeCategroyDto) =>
      quantityTypeCategoryService.updateCategory(item),
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.invalidateQueries(QUERY_KEYS.QUANTITY_TYPE_CATEGORIES)
        }
      },
    },
  )
}
